var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 101,
    viewBox: "0 0 96 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.0028 27.1364C92.7508 31.8038 93.2452 38.0175 92.4858 45.7773C91.7426 53.3721 89.4481 60.4846 85.6025 67.115C81.7731 73.58 77.1123 78.9656 71.6204 83.2714C60.3694 92.357 48.246 96.2763 35.2505 95.0287C22.6916 93.823 14.2679 88.0982 9.9792 77.8536C7.67302 72.1325 6.88342 65.5574 7.61046 58.1278C9.04842 43.4336 15.2937 30.8675 26.3463 20.4294C37.3989 9.99131 49.8052 5.43274 63.5655 6.75373C77.4348 8.08518 86.5804 14.8794 91.0028 27.1364Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 44.7822C0 20.0497 20.2427 0 45.2134 0C70.1841 0 90.4269 20.0497 90.4269 44.7822C90.4269 69.5148 70.1841 89.5645 45.2134 89.5645C20.2427 89.5645 0 69.5148 0 44.7822ZM45.2134 8.14222C24.7829 8.14222 8.22062 24.5465 8.22062 44.7822C8.22062 65.018 24.7829 81.4222 45.2134 81.4222C65.644 81.4222 82.2063 65.018 82.2063 44.7822C82.2063 24.5465 65.644 8.14222 45.2134 8.14222ZM30.6814 30.3886C32.2866 28.7987 34.8891 28.7987 36.4943 30.3886L45.2135 39.0247L53.9328 30.3886C55.538 28.7987 58.1405 28.7987 59.7457 30.3886C61.3509 31.9784 61.3509 34.5561 59.7457 36.146L51.0264 44.7821L59.7457 53.4183C61.3509 55.0081 61.3509 57.5858 59.7457 59.1757C58.1405 60.7655 55.538 60.7655 53.9328 59.1757L45.2135 50.5395L36.4943 59.1757C34.8891 60.7655 32.2866 60.7655 30.6814 59.1757C29.0762 57.5858 29.0762 55.0081 30.6814 53.4183L39.4007 44.7821L30.6814 36.146C29.0762 34.5561 29.0762 31.9784 30.6814 30.3886Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.16136f56752a3bf9af6d5d10b40cda06.svg";
export { ForwardRef as ReactComponent };